<template>
  <div class="users">
    <div class="users__subheader mb-4" v-if="!showForm">
      <add-button class="mr-4" @click="showAddForm"></add-button>
      <limit-component  v-if="users.length >= 10" v-model="limit" @input="getUsers"></limit-component>
    </div>
    <spinner v-if="isBusy"/>
    <div class="tech" v-show="!isBusy">
      <div class="developers__wrapper" v-if="!showForm">
        <custom-table v-if="$store.state.tableView.users"
                      class="mb-4"
                      :rows="rows"
                      :items="users"
                      @edit="showEditForm"
                      @archive="archiveUser"
                      >
          <template slot="role" slot-scope="{ item }">
            {{roles[item.role]}}
          </template>
        </custom-table>
        <div class="users__cards" v-if="!this.$store.state.tableView.users && !showMore">
          <custom-card v-for="item in users"
                        :key="item.id"
                        :item="item"
                        @show-more="showEditForm(item)"
                        >
            <template slot="icon">{{item.firstName.substring(0,1)}} {{item.lastName.substring(0,1)}}</template>
            <template slot="title">{{item.firstName}} {{item.lastName}}</template>
            <template slot="content"><span>{{roles[item.role]}}</span><span>{{item.login}}</span></template>
          </custom-card>
        </div>
        <pagination v-if="totalPages > 1"
                    :page-count="totalPages"
                    :click-handler="onChangePage"
        />
      </div>
      <user-form v-if="showForm"
                 :user="formUser"
                 :mode="formMode"
                 @close="showForm = false"
                 @add="addUser"
                 @edit="updateUser"
                 @archive="archiveUser" />
    </div>
  </div>
</template>

<script>
  import CustomTable from './UIComponents/CustomTable';
  import CustomCard from './UIComponents/CustomCard';
  import Pagination from './UIComponents/Pagination';
  import LimitComponent from './UIComponents/LimitComponent';
  import AddButton from './UIComponents/AddButton';
  import UserForm from './UserForm';
  import Spinner from './UIComponents/Spinner';
  import { Auth } from "./../api";
  import roles from './../helpers/roles';

  export default {
    name: "Users",
    components: {
      CustomTable,
      CustomCard,
      Pagination,
      LimitComponent,
      AddButton,
      UserForm,
      Spinner
    },
    data() {
      return {
        users: [],
        limit: 10,
        offset: 0,
        filter: { search: this.$store.state.search },
        totalRows: 0,
        rows: [
          {field: 'login', label: 'Логин', align: 'center'},
          {field: 'firstName', label: 'Имя', align: 'center'},
          {field: 'lastName', label: 'Фамилия', align: 'center'},
          {field: 'role', label: 'Роль', align: 'center'},
        ],
        formUser: {},
        formMode: 'edit',
        showForm: false,
        userMore: {},
        showMore: false,
        isBusy: true,
        roles
      }
    },
    computed: {
      totalPages: function () {
        return Math.ceil(this.totalRows / this.limit);
      }
    },
    watch: {
      '$store.state.search': function(search) {
        this.filter.search = search;
        this.getUsers();
      }
    },
    methods: {
      showAddForm() {
        this.formUser = {};
        this.formMode = 'add';
        this.showForm = true;
      },
      showEditForm(user) {
        this.formUser = Object.assign({}, user);
        this.formMode = 'edit';
        this.showForm = true;
      },
      addUser(user) {
        this.isBusy = true;
        return this.$API.post('user', user)
          .then(() => {
            this.showForm = false;
            this.getUsers();
          })
          .catch(() => {
            this.isBusy = false;
          })
      },
      updateUser(user, message = 'Пользователь успешно обновлен!') {
        this.isBusy = true;
        return this.$API.put(`user/${user.id}`, user)
          .then(() => {
            this.$notify({type: 'success', message});
            if (Auth.user.id === user.id) {
              Auth.logout(this.$API);
              return this.$router.push('/auth');
            }
            this.showForm = false;
            return this.getUsers();
          })
          .catch(() => {
            this.isBusy = false;
          })
      },
      archiveUser(user) {
        return this.updateUser({id: user.id, deleted: 1}, 'Пользователь успешно архивирован!');
      },
      onChangePage(page) {
        this.offset = (page - 1) * this.limit;
        this.getUsers();
      },
      getUsers() {
        this.isBusy = true;
        return this.$API.get('users', {params: {...this.filter, limit: this.limit, offset: this.offset}})
          .then(response => {
            this.users = response.data.rows;
            this.totalRows = response.data.count;
            this.isBusy = false;
          });
      }
    },
    created() {
      this.getUsers();
      if (window.innerWidth <= 780) {
        this.$store.commit("mobileSettings",this.$route.name)
      }
    }
  }
</script>

<style lang="scss" scoped>
.users {
  position: relative;

  &__subheader {
    display: flex;
    align-items: center;
  }

  &__cards {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    span {
      word-wrap: break-word;
    }

    @media screen and (max-width: 870px) {
        justify-content: center;
    }
  }
}
</style>